// vimbal earth palette: warm neutrals, earth tones, copper accent.
// Contrast notes: pebble, terracotta and copper pass AA (4.5:1) on linen/limestone;
// on sand use them for large text only.
export const colors = {
  // neutrals
  linen: "#FAF7F1",
  limestone: "#F4EFE6",
  sand: "#E9E0D0",
  stone: "#D6CAB8",
  pebble: "#766657",
  bark: "#5B4D42",
  ink: "#2A231E",

  // earth tones
  moss: "#4F6445",
  sage: "#A3B18F",
  ocean: "#2C5868",
  mist: "#9DB8BF",
  terracotta: "#9A4E2E",
  clay: "#D8A889",
  walnut: "#6A4A36",

  // deep grounds for the dark bands
  forest: "#1E2A22",
  forestSoft: "#2A382E",

  // metallic accent, CTAs and highlights only
  copper: "#8F5329",
  copperGlow: "#B87333",
  copperLight: "#D19A66",
};

export const copperGradient = `linear-gradient(100deg, ${colors.copperLight} 0%, ${colors.copperGlow} 45%, ${colors.copper} 100%)`;

export const fonts = {
  display: `"Fraunces", Georgia, "Times New Roman", serif`,
  body: `"Source Sans 3", "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif`,
  mono: `"IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace`,
};

export const media = {
  small: `(min-width: 660px)`,
  medium: `(min-width: 900px)`,
  large: `(min-width: 1200px)`,
  // Layout switch for the brain pages (30 Sep 2026, after the iPad failure): "wide" is any screen at
  // least 900px wide in landscape (desktops, laptops, iPads held sideways) and gets the two-column
  // layouts; everything else, phones and portrait tablets, gets the stacked layouts. The two
  // queries are exact opposites, so no screen size falls between them.
  wide: `(min-width: 900px) and (min-aspect-ratio: 1001/1000)`,
  narrow: `(max-width: 899px), (max-aspect-ratio: 1/1)`,
};

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Rotating accents for the stat / audience rhythm down the page
export const accents = [colors.moss, colors.ocean, colors.terracotta, colors.walnut, colors.copper];
